import {configureStore} from '@reduxjs/toolkit';
import {departmentsSlice,employeesSlice,shiftsSlice,shiftDetailsSlice,configSlice} from './features'

const store = configureStore({
    reducer: {
        configs:configSlice,
        departments:departmentsSlice,
        employees:employeesSlice,
        shifts:shiftsSlice,
        shiftDetails:shiftDetailsSlice
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({
        serializableCheck: false
    })
});

export default store;
